import { FC, useMemo } from "react";
import style from "./NotAllowedUserPage.module.scss";
import { DeviceMobileIcon } from "@phosphor-icons/react";
import Typhography from "../../shared/Typhography/Typhography";
import CustomButton from "../../shared/CustomButton/CustomButton";
import { useCustomKeycloak } from "../../hooks/useCustomKeycloak";
import { useAppSelector } from "../../store";
import { USER_TYPES } from "../../enums/user";


export const NotAllowedUserPage: FC = () => {
  const entities = useAppSelector((st) => st.me.entities);

  const options = useMemo(() => {
    if (!entities) return [];
    const directors = entities.directors.map((item) => ({
      label: item.name,
      value: item,
    }));
    const users = entities.users.map((item) => {
      if (item.type === USER_TYPES.ATHLETE) return [];

      return {
        label: `${item.directorId.name}: ${item.type}:`,
        value: item,
      };
    });
    return [...directors, ...users];
  }, [entities]);
  const { keycloak } = useCustomKeycloak();
  return (
    <div className={style.pageContainer}>
      <div className={style.backgroundImage}></div>
      <div className={style.contentContainer}>
        <DeviceMobileIcon color="#FFD15A" size={"100"} />
        <Typhography size="bold-40" className={style.description}>
          Installa l'applicazione mobile
        </Typhography>
        <Typhography size="medium-20" className={style.description}>
          Le utenze di tipologia atleta possono accedere solo attraverso
          l'applicazione mobile
        </Typhography>
        <CustomButton
          className="mt-5"
          onClick={() => {
            keycloak.logout();
          }}
        >
          Logout
        </CustomButton>
      </div>
    </div>
  );
};
